/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Fragment, useCallback, useMemo, useRef, useState } from 'react';
import { useEffect } from 'react';

import { FormHandles, Scope } from '@unform/core';
import { Form } from '@unform/web';
import { IoIosArrowBack } from 'react-icons/io';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import {
  ButtonBlack,
  Input,
  Layout,
  Select,
  Textarea,
  TimeInput,
} from '~/components';
import { useAuth } from '~/hooks/auth';
import api from '~/services/api';
import { formatHMS, getSeconds } from '~/utils';
import getValidationErrors from '~/utils/getValidationErrors';

import Modal from './Modal';
import {
  PowerCreatorFormProps,
  InitialPowerCreatorFormProps,
  SelectProps,
} from './types';

import * as S from './styles';

export default function PowerCreatorEdit() {
  const { go, goBack, location } = useHistory();
  const { user } = useAuth();
  const formRef = useRef<FormHandles>(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const InputStyles = {
    input: {
      height: '3.8rem',
      padding: '0 1.7rem',
    },
    textArea: {
      height: '13.1rem',
      padding: '2rem',
      borderRadius: '1rem',
    },
  };

  const maxLengthOptions = useCallback((key: number) => {
    const options: { [key: number]: number } = {
      1: 0,
      2: 3,
      3: 7,
      4: 10,
      5: 13,
      6: 16,
      7: 19,
      8: 22,
      9: 25,
      10: 28,
    };

    return options[key];
  }, []);

  useEffect(() => {
    const initialData =
      location.state as unknown as InitialPowerCreatorFormProps;

    if (formRef.current) {
      formRef.current?.setFieldValue(
        'tranning_method',
        initialData.tranning_method,
      );

      formRef.current?.setFieldValue(
        'method_principle',
        initialData.method_principle,
      );
      setSelectedPrinciples(initialData.method_principle.split('&'));
      formRef.current?.setFieldValue('execution', initialData.execution);

      formRef.current?.setFieldValue(
        'technical_description',
        initialData.technical_description,
      );

      const numberOfSeriesSelect = {
        label: `${initialData.series_number}`,
        value: `${initialData.series_number}`,
      };
      setDefaultSerieNumber(numberOfSeriesSelect);
      setSerieNumber(+initialData.series_number);
      const recoveryIntervalLength =
        initialData.recovery_interval_between_series.replaceAll('/', '').length;

      // console.log(recoveryIntervalLength, (+initialData.series_number - 1) * 3);

      (+initialData.series_number - 1) * 3 !== recoveryIntervalLength &&
        formRef.current?.setFieldError(
          'recovery_interval_between_series',
          'O intervalo precisa ser configurado novamente!',
        );

      formRef.current?.setFieldValue(
        'recovery_interval_between_series',
        initialData.recovery_interval_between_series,
      );
      setRecoveryTimeInterval(initialData.recovery_interval_between_series);
      setMaxChar(maxLengthOptions(+initialData.series_number));
    }
  }, [location.state, maxLengthOptions]);

  const [loading, setLoading] = useState(false);
  const [showPrincipleModal, setShowPrincipleModal] = useState(false);
  const [selectedPrinciples, setSelectedPrinciples] = useState<string[]>([]);
  const [recoveryTimeInterval, setRecoveryTimeInterval] = useState('');
  const [maxChar, setMaxChar] = useState(0);
  const [serieNumber, setSerieNumber] = useState(1);
  const [defaultSerieNumber, setDefaultSerieNumber] = useState(
    {} as SelectProps,
  );
  const [initialData] = useState(
    location.state as unknown as InitialPowerCreatorFormProps,
  );
  const [intervalGlobal, setIntervalGlobal] = useState('');
  const [recoveryIntervalArr, setRecoveryIntervalArr] = useState(
    Object.values(initialData.series_recovery_Time),
  );
  const [seriesNames] = useState(Object.values(initialData.series_names));
  const [seriesActionTimes] = useState(
    Object.values(initialData.series_actions_time),
  );
  const [seriesNumberOfRepetitions] = useState(
    Object.values(initialData.series_number_of_repetitions),
  );
  const [seriesRecoveryTime, setSeriesRecoveryTime] = useState(
    Object.values(initialData.series_recovery_Time),
  );
  const numberOfSeriesMemo = useMemo(
    () => [
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8' },
      { value: '9', label: '9' },
      { value: '10', label: '10' },
    ],
    [],
  );

  const principlesMemo = useMemo(
    () => [
      { label: 'ARCO DE MOVIMENTO', value: 'ARCO DE MOVIMENTO' },
      { label: 'CARGA ALTA', value: 'CARGA ALTA' },
      { label: 'CARGA PROGRESSÃO', value: 'CARGA PROGRESSÃO' },
      { label: 'CARGA REGRESSÃO', value: 'CARGA REGRESSÃO' },
      { label: 'DESCANSO ATIVO', value: 'DESCANSO ATIVO' },
      { label: 'HIPERTROFIA', value: 'HIPERTROFIA' },
      { label: 'INTERVALO DE RECUPERAÇÃO', value: 'INTERVALO DE RECUPERAÇÃO' },
      { label: 'ISOMETRIA', value: 'ISOMETRIA' },
      { label: 'PICO DE CONTRAÇÃO', value: 'PICO DE CONTRAÇÃO' },
      { label: 'RESISTÊNCIA', value: 'RESISTÊNCIA' },
      { label: 'VELOCIDADE DE EXECUÇÃO', value: 'VELOCIDADE DE EXECUÇÃO' },
      { label: 'VOLUME', value: 'VOLUME' },
    ],
    [],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const series: { [key: string]: Array<number> } = {
    1: [0],
    2: [0, 1],
    3: [0, 1, 2],
    4: [0, 1, 2, 3],
    5: [0, 1, 2, 3, 4],
    6: [0, 1, 2, 3, 4, 5],
    7: [0, 1, 2, 3, 4, 5, 6],
    8: [0, 1, 2, 3, 4, 5, 6, 7],
    9: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    10: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  };

  const handleNumberOfSeriesChange = useCallback(() => {
    const formList = formRef.current?.getData().series_number_of_repetitions;

    const totalNumberOfSeries = Object.values(formList).reduce(
      (reducer, current) => Number(reducer) + Number(current),
    );

    formRef.current?.setFieldValue('volume_total', totalNumberOfSeries || 0);
  }, []);

  const calculateTotalTime = useCallback(() => {
    try {
      const formListActionTimes =
        formRef.current?.getData().series_actions_time;

      const totalActionTimeNumber =
        formListActionTimes &&
        Object.values(formListActionTimes)
          .map((time) => {
            const sTime = String(time).length < 8 ? `${time}:00` : String(time);
            return getSeconds(sTime);
          })
          .reduce((reducer, current) => current + reducer);

      const formListRecoveryTime =
        formRef.current?.getData().series_recovery_Time;

      const totalRecoveryTimeNumber =
        formListRecoveryTime &&
        Object.values(formListRecoveryTime)
          .map((time) => {
            const sTime = String(time).length < 8 ? `${time}:00` : String(time);
            return getSeconds(sTime);
          })
          .reduce((reducer, current) => current + reducer);

      formRef.current?.setFieldValue(
        'total_time',
        formatHMS(
          (totalActionTimeNumber || 0) + (totalRecoveryTimeNumber || 0),
        ),
      );
    } catch (err) {
      //
      console.log(err);
    }
  }, []);

  const handleActionTimeChange = useCallback(() => {
    const formList = formRef.current?.getData().series_actions_time;

    const totalActionTimeNumber = Object.values(formList)
      .map((time) => {
        const sTime = String(time).length < 8 ? `${time}:00` : String(time);
        return getSeconds(sTime);
      })
      .reduce((reducer, current) => current + reducer);

    formRef.current?.setFieldValue(
      'total_action',
      formatHMS(totalActionTimeNumber),
    );

    calculateTotalTime();
  }, [calculateTotalTime]);

  const handleRecoveryTimeChange = useCallback(() => {
    const formList = formRef.current?.getData().series_recovery_Time;

    if (formList) {
      const totalRecoveryTimeNumber = Object.values(formList)
        .map((time) => {
          const sTime = String(time).length < 8 ? `${time}:00` : String(time);
          return getSeconds(sTime);
        })
        .reduce((reducer, current) => current + reducer);
      formRef.current?.setFieldValue(
        'interval_recovery_total',
        formatHMS(totalRecoveryTimeNumber),
      );

      calculateTotalTime();
    }
  }, [calculateTotalTime]);

  const handleGlobalRecoveryTimeChange = useCallback(() => {
    const recTime = formRef.current
      ?.getFieldValue('recovery_interval_between_series')
      .substr(0, maxChar);
    // setRecoveryTimeInterval(recTime);

    calculateTotalTime();

    if (maxChar === 0) {
      formRef.current?.setFieldValue('interval_recovery_total', formatHMS(0));
      formRef.current?.setFieldValue(
        'series_recovery_Time.time_of_recovery_serie_1',
        formatHMS(0),
      );
    }
  }, [maxChar, calculateTotalTime]);

  // recalculate total values on number of series change
  useEffect(() => {
    handleNumberOfSeriesChange();
    handleActionTimeChange();
    handleGlobalRecoveryTimeChange();
  }, [
    handleNumberOfSeriesChange,
    handleActionTimeChange,
    calculateTotalTime,
    handleGlobalRecoveryTimeChange,
    serieNumber,
  ]);

  // set recovery interval on series recovery interval
  useEffect(() => {
    try {
      const formList = formRef.current?.getData().series_recovery_Time;

      const intervalSecondsValue = recoveryTimeInterval.split('/');
      Object.keys(formList).map((intervalField, index) =>
        formRef.current?.setFieldValue(
          `series_recovery_Time.${intervalField}`,
          formatHMS(+intervalSecondsValue[index] || 0),
        ),
      );
      handleRecoveryTimeChange();
    } catch (err) {
      //
    }
  }, [recoveryTimeInterval, handleRecoveryTimeChange]);

  const SeriesLogicMemo = useMemo(
    () =>
      series[serieNumber].map((serie) => (
        <Fragment key={serie}>
          <div className="double-input">
            <fieldset>
              <Scope path="series_names">
                <label htmlFor={`name_of_serie_${serie + 1}`}>
                  Série {serie + 1} - execução:
                </label>

                <Input
                  name={`name_of_serie_${serie + 1}`}
                  defaultValue={seriesNames[serie]}
                  placeholder="Execução"
                  containerStyle={InputStyles.input}
                  fontSize="1.5rem"
                />
              </Scope>
            </fieldset>

            <fieldset>
              <Scope path="series_number_of_repetitions">
                <label htmlFor={`repetitions_serie_${serie + 1}`}>
                  Número de repetições:
                </label>
                <Input
                  type="number"
                  defaultValue={seriesNumberOfRepetitions[serie]}
                  min={1}
                  placeholder="Repetições"
                  name={`repetitions_serie_${serie + 1}`}
                  containerStyle={InputStyles.input}
                  fontSize="1.5rem"
                  onChange={handleNumberOfSeriesChange}
                />
              </Scope>
            </fieldset>
          </div>

          <div className="double-input">
            <fieldset>
              <Scope path="series_actions_time">
                <label htmlFor={`action_time_serie_${serie + 1}`}>
                  Tempo de ação:
                </label>

                <Input
                  type="time"
                  min="00:00:01"
                  defaultValue={seriesActionTimes[serie] ?? '00:00:00'}
                  name={`action_time_serie_${serie + 1}`}
                  containerStyle={InputStyles.input}
                  fontSize="1.5rem"
                  placeholder="00:00:00"
                  onChange={handleActionTimeChange}
                />
              </Scope>
            </fieldset>

            <fieldset
              className={serie + 1 === +serieNumber ? 'hide-fieldset' : ''}
            >
              <Scope path="series_recovery_Time">
                <label htmlFor={`time_of_recovery_serie_${serie + 1}`}>
                  Intervalo de recuperação (entre séries):
                </label>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <Input
                    key={`${serie}-${seriesRecoveryTime[serie]}`}
                    disabled={serie + 1 === +serieNumber}
                    readOnly
                    type="text"
                    min="00:00:01"
                    onChange={handleRecoveryTimeChange}
                    value={recoveryIntervalArr[serie] ?? '00:00:00'}
                    name={`time_of_recovery_serie_${serie + 1}`}
                    containerStyle={InputStyles.input}
                    fontSize="1.5rem"
                  />
                </div>
              </Scope>
            </fieldset>
          </div>

          <S.Divider />
        </Fragment>
      )),
    [
      series,
      serieNumber,
      seriesNames,
      InputStyles.input,
      seriesNumberOfRepetitions,
      handleNumberOfSeriesChange,
      seriesActionTimes,
      handleActionTimeChange,
      seriesRecoveryTime,
      handleRecoveryTimeChange,
      recoveryIntervalArr,
    ],
  );

  const handleCheckBoxClick = useCallback(
    (value: string) => {
      selectedPrinciples.includes(value)
        ? setSelectedPrinciples((prev) =>
            prev.filter((principle) => principle !== value),
          )
        : setSelectedPrinciples((prev) => [...prev, value]);
    },
    [selectedPrinciples],
  );

  const PrincipleOptionsCheckBox = useMemo(
    () =>
      principlesMemo.map((item) => (
        <S.CheckboxContainer
          key={item.value}
          onClick={() => handleCheckBoxClick(item.value)}
        >
          <S.Checkbox isFilled={selectedPrinciples.includes(item.value)}>
            <div className="filled" />
          </S.Checkbox>

          <p>{item.label}</p>
        </S.CheckboxContainer>
      )),
    [handleCheckBoxClick, principlesMemo, selectedPrinciples],
  );

  const formattingRecoveryGlobalText = (value: string) => {
    const valueOnlyNumbers = value.replace(/\D/g, '');
    const txtFaseOne = valueOnlyNumbers.replace(
      /([0-9])([0-9])([0-9])/g,
      `$1$2$3/`,
    );
    const txtFaseTwo = txtFaseOne.split('/');
    const txtFaseThree = txtFaseTwo.filter((item) => item !== '');
    const txtFaseFour = txtFaseThree.join('/');
    setRecoveryTimeInterval(txtFaseFour);
    setIntervalGlobal(txtFaseFour);
  };

  function setPrincipleFieldValue() {
    formRef.current?.setFieldValue(
      'method_principle',
      selectedPrinciples.join('&'),
    );

    setShowPrincipleModal(false);
  }

  useEffect(() => {
    function takeChangerNumberOfSeries() {
      if (recoveryIntervalArr.length !== 1) {
        if (serieNumber >= 1) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_1',
            recoveryIntervalArr[0],
          );
        }
        if (serieNumber >= 2) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_2',
            recoveryIntervalArr[1],
          );
        }
        if (serieNumber >= 3) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_3',
            recoveryIntervalArr[2],
          );
        }
        if (serieNumber >= 4) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_4',
            recoveryIntervalArr[3],
          );
        }
        if (serieNumber >= 5) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_5',
            recoveryIntervalArr[4],
          );
        }
        if (serieNumber >= 6) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_6',
            recoveryIntervalArr[5],
          );
        }
        if (serieNumber >= 7) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_7',
            recoveryIntervalArr[6],
          );
        }
        if (serieNumber >= 8) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_8',
            recoveryIntervalArr[7],
          );
        }
        if (serieNumber >= 9) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_9',
            recoveryIntervalArr[8],
          );
        }
        if (serieNumber === 10) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_10',
            recoveryIntervalArr[9],
          );
        }
      } else {
        if (serieNumber >= 1) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_1',
            recoveryIntervalArr[0],
          );
        }
        if (serieNumber >= 2) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_2',
            recoveryIntervalArr[0],
          );
        }
        if (serieNumber >= 3) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_3',
            recoveryIntervalArr[0],
          );
        }
        if (serieNumber >= 4) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_4',
            recoveryIntervalArr[0],
          );
        }
        if (serieNumber >= 5) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_5',
            recoveryIntervalArr[0],
          );
        }
        if (serieNumber >= 6) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_6',
            recoveryIntervalArr[0],
          );
        }
        if (serieNumber >= 7) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_7',
            recoveryIntervalArr[0],
          );
        }
        if (serieNumber >= 8) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_8',
            recoveryIntervalArr[0],
          );
        }
        if (serieNumber >= 9) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_9',
            recoveryIntervalArr[0],
          );
        }
        if (serieNumber === 10) {
          formRef?.current?.setFieldValue(
            'series_recovery_Time.time_of_recovery_serie_10',
            recoveryIntervalArr[0],
          );
        }
      }
    }
    if (serieNumber > 1) takeChangerNumberOfSeries();
  }, [recoveryIntervalArr, serieNumber, seriesRecoveryTime]);

  function PrincipleModal() {
    return (
      <Modal
        isOpen={showPrincipleModal}
        setOpen={setShowPrincipleModal}
        maxHeightStyled="70rem"
      >
        <S.PrincipleModalContainer>
          <h1>Princípio ativo</h1>

          <div className="container">{PrincipleOptionsCheckBox}</div>

          <ButtonBlack onClick={setPrincipleFieldValue}>Salvar</ButtonBlack>
        </S.PrincipleModalContainer>
      </Modal>
    );
  }

  const handleSubmit = useCallback(
    async (data: PowerCreatorFormProps) => {
      setLoading((prev) => !prev);

      const schema = Yup.object().shape({
        professional_id: Yup.number().required(),
        tranning_method: Yup.string().required(),
        execution: Yup.string().required(),
        technical_description: Yup.string().required(),
        method_principle: Yup.string().required(),
        series_number: Yup.string().required(),
        volume_total: Yup.string().required(),
        total_action: Yup.string().required(),
        total_time: Yup.string().required(),
        recovery_interval_between_series: Yup.string().test(
          'Serie number must be at least 2 to validate',
          'O campo é obrigatório!',
          (value) => {
            if (serieNumber === 1) {
              return true;
            }
            return value !== '';
          },
        ),
        series_actions_time: Yup.object().required(),
        series_names: Yup.object().required(),
        series_number_of_repetitions: Yup.object().required(),
        interval_recovery_total: Yup.string().required(),
      });

      const formData = {
        ...data,
        professional_id: user.professional.id,
        recovery_interval_between_series:
          serieNumber === 1 ? 0 : data.recovery_interval_between_series,
      };

      try {
        await schema.validate(formData, { abortEarly: false });

        await api.put(`power-creators/${initialData.id}`, formData);

        toast.success('Treinamento criado com sucesso!');

        go(-2);
        setLoading((prev) => !prev);
      } catch (err) {
        setLoading((prev) => !prev);

        console.log(err);

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
        }

        toast.error('Erro ao criar treinamento.');
      }
    },
    [go, user, serieNumber, initialData.id],
  );

  useEffect(() => {
    function formatingIntervalRecoveryText() {
      for (let index = 0; index <= 10; index += 1) {
        if (serieNumber === index + 1) {
          setMaxChar(3 * serieNumber + index - 4);
        }
      }

      const intervalGlobalWithOutSlashes = intervalGlobal.replaceAll('/', '');

      if (intervalGlobal.length >= 3) {
        const txtFaseOne: string[] = [];
        for (
          let index = 0;
          index < intervalGlobalWithOutSlashes.length;
          index += 1
        ) {
          const twoMultiple = intervalGlobalWithOutSlashes.slice(
            index,
            index + 3,
          );
          if (index % 3 === 0) {
            txtFaseOne.push(twoMultiple);
          }
        }

        const txtFaseTwoArrays = txtFaseOne.map((item) => {
          if (txtFaseOne.length !== 0) {
            return formatHMS(Number(item));
          }
          return formatHMS(0);
        });

        const txtFaseThree = [...txtFaseTwoArrays];

        if (txtFaseTwoArrays.length < serieNumber) {
          for (
            let index = txtFaseTwoArrays.length;
            index < serieNumber - 1;
            index += 1
          ) {
            txtFaseThree.push(txtFaseTwoArrays[txtFaseTwoArrays.length - 1]);
          }
        }
        setRecoveryIntervalArr(txtFaseThree);
      }

      if (intervalGlobal.length <= 3) {
        const time = formatHMS(Number(intervalGlobal));
        // it was setting to 0 time
        // setRecoveryIntervalArr([time]);
      }
    }

    formatingIntervalRecoveryText();
  }, [intervalGlobal, serieNumber]);

  return (
    <Layout title="Power Creator">
      <PrincipleModal />

      <S.Header>
        <S.HeaderWrapper onClick={() => goBack()}>
          <IoIosArrowBack color="#FFDF22" size={24} />
          <S.HeaderLabel>Power Creator</S.HeaderLabel>
        </S.HeaderWrapper>

        <S.SaveButton
          disabled={loading}
          onClick={() => formRef.current?.submitForm()}
        >
          Salvar
        </S.SaveButton>
      </S.Header>

      <S.Container>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <fieldset>
            <label htmlFor="tranning_method">Método</label>

            <Input
              name="tranning_method"
              placeholder="Nome do método"
              containerStyle={InputStyles.input}
              fontSize="1.5rem"
            />
          </fieldset>

          <div className="double-input">
            <fieldset
              className="field-hover"
              onClick={() => setShowPrincipleModal(true)}
            >
              <label htmlFor="method_principle">Princípio</label>

              <Input
                disabled
                placeholder="Selecione um princípio ativo"
                name="method_principle"
                containerStyle={InputStyles.input}
                fontSize="1.5rem"
              />
            </fieldset>

            <fieldset>
              <label htmlFor="execution">Execução</label>

              <Input
                name="execution"
                placeholder="Execução do método"
                containerStyle={InputStyles.input}
                fontSize="1.5rem"
              />
            </fieldset>
          </div>

          <div className="double-input">
            <fieldset>
              <label htmlFor="technical_description">Descrição Técnica</label>

              <div className="text-area-container">
                <Textarea
                  name="technical_description"
                  placeholder="Descrição"
                />
              </div>
            </fieldset>

            <div>
              <fieldset>
                <label htmlFor="series_number">Volume Nº de séries:</label>

                <Select
                  key={`rerender_key_${defaultSerieNumber.value}`}
                  name="series_number"
                  options={numberOfSeriesMemo}
                  isSearchable={false}
                  defaultValue={defaultSerieNumber}
                  onChange={(e) => {
                    setMaxChar(maxLengthOptions(e?.value));
                    setSerieNumber(+e?.value);
                  }}
                  styles={{
                    placeholder: () => ({
                      padding: '0 1rem',
                      color: '#00000080',
                    }),
                    singleValue: () => ({
                      padding: '0 1rem',
                    }),
                  }}
                />
              </fieldset>

              <fieldset>
                <label htmlFor="recovery_interval_between_series">
                  Intervalo de recuperação (entre séries):
                </label>

                <Input
                  disabled={+serieNumber === 1}
                  name="recovery_interval_between_series"
                  placeholder="Ex: 060/030/010"
                  maxLength={maxChar}
                  value={recoveryTimeInterval}
                  onChange={(e) => {
                    formattingRecoveryGlobalText(e?.target?.value);
                    handleRecoveryTimeChange();
                  }}
                  containerStyle={InputStyles.input}
                  fontSize="1.5rem"
                />
              </fieldset>
            </div>
          </div>

          <S.Divider />

          {SeriesLogicMemo}

          <div className="double-input">
            <fieldset>
              <label htmlFor="volume_total">Volume Nº repetições:</label>

              <Input
                disabled
                name="volume_total"
                defaultValue="0"
                containerStyle={InputStyles.input}
                fontSize="1.5rem"
              />
            </fieldset>

            <fieldset>
              <label htmlFor="total_action">Tempo de ação Total:</label>

              <Input
                disabled
                name="total_action"
                defaultValue="00:00:00"
                containerStyle={InputStyles.input}
                fontSize="1.5rem"
              />
            </fieldset>
          </div>

          <div className="double-input">
            <fieldset>
              <label htmlFor="total_recovery_total">
                Intervalo de recuperação total:
              </label>

              <Input
                disabled
                placeholder="Selecione um princípio ativo"
                name="interval_recovery_total"
                defaultValue="00:00:00"
                containerStyle={InputStyles.input}
                fontSize="1.5rem"
              />
            </fieldset>

            <fieldset>
              <label htmlFor="total_time">Tempo Total:</label>

              <Input
                disabled
                name="total_time"
                defaultValue="00:00:00"
                containerStyle={InputStyles.input}
                fontSize="1.5rem"
              />
            </fieldset>
          </div>
        </Form>
      </S.Container>
    </Layout>
  );
}
